import { getYear } from "date-fns";

export class MSMonthRangeDefaultValues {
  static readonly StartDate = null;
  static readonly EndDate = null;
  static readonly InitialEndDate = new Date();
  static readonly MinYear = 2000;
  static readonly MaxYear = getYear(new Date());
}

export class MSMonthRangePickerMessage {
  static readonly Performance =
    "<p>Default view shows performance up to the latest available month for each model. Set an <strong>end date</strong> to align the performance period across models. Set both a <strong>start and end date</strong> to view performance over a custom range.</p>";
}
